module.exports = __webpack_public_path__ + "static/main_02-0593770021f425ee295da2288c5c723c.png";